<template>
  <b-tabs content-class="mt-3" class="tabs-secciones">
    <b-tab title="Informacion General" @click="cambiarSeccion('general')">
      <template #title>
        <div class="title-tab">
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/general.svg"
            title="My Image"
          />
          <p class="titulo text-center">Información General</p>
        </div>
      </template>
      <informacion-general
        v-if="secciones.general"
        :despacho="despacho"
        :postInformacionGeneral="postInformacionGeneral"
        :informacionGeneral="informacionGeneral"
        tipo="tramitador_aduanero"
      >
      </informacion-general>
    </b-tab>
    <b-tab title="Documentación" @click="cambiarSeccion('documentos')">
      <template #title>
        <div class="title-tab">
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/documento.svg"
            title="My Image"
          />
          <p class="titulo text-center">Documentación</p>
        </div>
      </template>
      <documentos
        v-if="todosDocumentos.tipos_documentos && secciones.documentos"
        :agregarDocumento="true"
        :postDocumento="postDocumento"
        :updateDocumento="updateDocumento"
        :documentosTabla="documentosTabla"
        :documentos="todosDocumentos"
        :eliminarDocumento="eliminarDocumento"
        :eliminarDocumentos="eliminarDocumentos"
        :showDeleteDocumentos="showDeleteDocumentos"
        :actualizarDocumentos="actualizarDocumentos"
        :confirmarDeleteDocumentos="confirmarDeleteDocumentos"
        :cerrarModal="cerrarModal"
        :metodoThen="metodoThen"
        :metodoCatch="metodoCatch"
      >
      </documentos>
    </b-tab>

    <b-tab title="Pagos" @click="cambiarSeccion('pagos')">
      <template #title>
        <div class="title-tab">
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/dollar.svg"
            title="My Image"
          />
          <p class="titulo text-center">Pagos</p>
        </div>
      </template>
      <pagos
        v-if="secciones.pagos"
        :despacho="despacho"
        :agregarPago="true"
        :postPago="postPago"
        :updatePago="updatePago"
        :pagosTabla="pagosTabla"
        :pagos="todosPagos"
        :getComprobante="getComprobante"
        :eliminarPago="eliminarPago"
      >
      </pagos>
    </b-tab>
    <b-tab title="Detalle Carga" @click="cambiarSeccion('carga')">
      <template #title>
        <div class="title-tab">
          <inline-svg
            class="icono-titulo"
            src="../../assets/images/containers.svg"
            title="My Image"
          />
          <p class="titulo text-center">Detalle Carga</p>
        </div>
      </template>
      <contenedores
        v-if="secciones.carga"
        :permiteAgregarContenedor="true"
        :despacho="despacho"
      >
      </contenedores>
    </b-tab>
  </b-tabs>
</template>

<script>
import axios from "axios";
import FormAsignarUsuario from "../../../formulario/FormAsignarUsuario.vue";
import Usuarios from "../../Componentes/Usuarios.vue";
import { mapActions } from "vuex";
import FormDocumento from "../../../formulario/FormDocumento.vue";
import Documentos from "../../Componentes/Documentos.vue";
import Pagos from "../../Componentes/Pagos.vue";
import InformacionGeneral from "../../Componentes/InformacionGeneral.vue";
import Contenedores from "../../Componentes/Contenedores.vue";
export default {
  components: {
    FormAsignarUsuario,
    Usuarios,
    Documentos,
    Pagos,
    InformacionGeneral,
    Contenedores,
  },

  props: {
    despacho: Object,

    submit: Function,
    estados: Object,

    //DOCUMENTOS
    documentos: Object,
    documentosTabla: Array,
    postDocumento: Function,
    updateDocumento: Function,

    showDeleteDocumentos: Boolean,
    eliminarDocumentos: Function,
    actualizarDocumentos: Function,
    confirmarDeleteDocumentos: Function,
    cerrarModal: Function,
    metodoThen: Function,
    metodoCatch: Function,

    //PAGOS
    pagos: Object,
    pagosTabla: Array,
    postPago: Function,
    updatePago: Function,

    //Informacion General
    postInformacionGeneral: Function,
    informacionGeneral: Object,

    eliminarDocumento: Function,
    eliminarPago: Function,
    getComprobante: Function,
  },

  data() {
    return {
      documentosPorRol: [],
      pagosPorRol: [],

      todosDocumentos: {},
      todosPagos: {},

      secciones: {
        general: true,
        carga: false,
        pagos: false,
        usuarios: false,
        documentos: false,
      },
    };
  },
  mounted() {
    this.documentosPorRol = [];
    this.documentos.tipos_documentos.forEach((el) => {
      this.documentosPorRol.push(el);
    });
    this.todosDocumentos = {
      tipos_documentos: this.documentosPorRol,
      bl: this.documentos.bl,
      documento_transporte: this.documentos.documento_transporte,
      tipos_vistos_buenos: this.documentos.tipos_vistos_buenos,
    };

    // this.pagosPorRol = []
    // this.pagos.tipos_pagos.forEach(el =>{
    //     if( el.id == 6 || el.id == 7) this.pagosPorRol.push(el)
    // });
    // this.todosPagos= {
    //     tipos_pagos: this.pagosPorRol,
    //     tipos_documentos_contable : this.pagos.tipo_documento_contable,
    // }
  },
  methods: {
    //secciones
    cambiarSeccion(seccion) {
      Object.keys(this.secciones).forEach((key) => {
        if (key == seccion) this.secciones[key] = true;
        else this.secciones[key] = false;
      });
    },
  },
};
</script>

<style></style>
